// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-input-outlined {\n  border: 1px solid #000101 !important;\n  transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;\n}\n.custom-phone {\n  border: none !important;\n}\n.custom-phone:focus-within {\n  border: none !important;\n  box-shadow: none !important;\n}\n.custom-phone .vti__dropdown {\n  background-color: transparent !important;\n}\n.custom-phone .vti__dropdown:hover {\n  background-color: transparent !important;\n}", ""]);
// Exports
module.exports = exports;
